import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import { Card } from '../components/ui';
import { Shield, Mail, MapPin } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-8 h-8 text-primary" />
            <h1 className="font-heading text-3xl">GİZLİLİK POLİTİKASI</h1>
          </div>
          
          <p className="text-muted-foreground mb-8">
            Son Güncelleme: 22 Mart 2026
          </p>

          <Card className="p-8 space-y-8">
            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">1. GİRİŞ</h2>
              <p className="text-muted-foreground leading-relaxed">
                CEREBRAI VORTX NÖROTEKNOLOJİ VE YAZILIM SİSTEMLERİ LİMİTED ŞİRKETİ ("CerebrAI-VorTX", "biz", "bizim") 
                olarak, InkTrack uygulaması kullanıcılarının gizliliğini korumayı taahhüt ediyoruz. Bu Gizlilik Politikası, 
                kişisel verilerinizi nasıl topladığımızı, kullandığımızı, sakladığımızı ve koruduğumuzu açıklamaktadır.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">2. TOPLANAN VERİLER</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                InkTrack uygulamasını kullanırken aşağıdaki verileri toplayabiliriz:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li><strong>Hesap Bilgileri:</strong> Ad, e-posta adresi, şifre (şifrelenmiş)</li>
                <li><strong>Profil Bilgileri:</strong> Profil fotoğrafı, tercihler</li>
                <li><strong>Dövme Verileri:</strong> Dövme fotoğrafları, konum bilgisi, tarihler, notlar</li>
                <li><strong>Sağlık Verileri:</strong> Smart Check analizleri için yüklenen fotoğraflar (ağrı seviyesi, belirtiler)</li>
                <li><strong>Kullanım Verileri:</strong> Uygulama kullanım istatistikleri, özellik tercihleri</li>
                <li><strong>Ödeme Bilgileri:</strong> Stripe aracılığıyla işlenen ödeme verileri (kart bilgileri bizde saklanmaz)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">3. VERİLERİN KULLANIMI</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Topladığımız verileri aşağıdaki amaçlarla kullanırız:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Uygulama hizmetlerini sağlamak ve iyileştirmek</li>
                <li>AI destekli dövme analizi yapmak (Smart Check)</li>
                <li>Kişiselleştirilmiş bakım önerileri sunmak</li>
                <li>Hatırlatıcı bildirimleri göndermek</li>
                <li>Müşteri desteği sağlamak</li>
                <li>Yasal yükümlülüklerimizi yerine getirmek</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">4. VERİ GÜVENLİĞİ</h2>
              <p className="text-muted-foreground leading-relaxed">
                Verilerinizi korumak için endüstri standardı güvenlik önlemleri uyguluyoruz:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground mt-4">
                <li>SSL/TLS şifreleme ile veri iletimi</li>
                <li>Şifrelenmiş veritabanı depolama</li>
                <li>Düzenli güvenlik denetimleri</li>
                <li>Erişim kontrolü ve yetkilendirme</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">5. ÜÇÜNCÜ TARAF HİZMETLER</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Hizmetlerimizi sağlamak için aşağıdaki üçüncü taraf hizmetleri kullanıyoruz:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li><strong>Google:</strong> Kimlik doğrulama (Google Sign-In)</li>
                <li><strong>Stripe:</strong> Ödeme işlemleri</li>
                <li><strong>Cloudinary:</strong> Görsel depolama</li>
                <li><strong>Google AI (Gemini):</strong> AI analiz hizmetleri</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">6. KVKK HAKLARI</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Kişisel verilerinizin düzeltilmesini veya silinmesini isteme</li>
                <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">7. VERİ SAKLAMA SÜRESİ</h2>
              <p className="text-muted-foreground leading-relaxed">
                Kişisel verilerinizi, hizmetlerimizi kullandığınız süre boyunca ve hesabınızı silmenizden itibaren 
                30 gün içinde sistemlerimizden kaldırırız. Yasal yükümlülükler gerektirdiği durumlarda veriler 
                daha uzun süre saklanabilir.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">8. İLETİŞİM</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Gizlilik politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-muted-foreground">
                  <Mail className="w-5 h-5 text-primary" />
                  <span>info@cerebrai-vortx.com</span>
                </div>
                <div className="flex items-start gap-3 text-muted-foreground">
                  <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                  <span>
                    Ulubağ Mah. Recep Tayyip Erdoğan Blv. Harran Üniversitesi Teknokent No: 287 A 
                    İç Kapı No: Z1 Haliliye / Şanlıurfa, Türkiye
                  </span>
                </div>
              </div>
            </section>
          </Card>

          <p className="text-center text-sm text-muted-foreground mt-8">
            © 2026 CEREBRAI VORTX NÖROTEKNOLOJİ VE YAZILIM SİSTEMLERİ LİMİTED ŞİRKETİ. Tüm hakları saklıdır.
          </p>
        </motion.div>
      </main>
    </div>
  );
};

export default Privacy;
